export const ROUTES = {
  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Dashboard
  DASHBOARD: '/',

  // Employees
  EMPLOYEES: '/employees',
  EMPLOYEE_REPORTING: '/employees/reporting',
  EMPLOYEE_PROFILE: '/employees/:id',
  EMPLOYEE_CUSTOM_FIELDS: '/employees/custom-fields',
  MY_INFO: '/employees/my-info',
  MY_TEAM: '/my-team',
  TEAM_CONFIRMATION: '/my-team/:id/confirmation',
  ORG_CHART: '/org-chart',

  // Leave
  LEAVE: '/leave',
  LEAVE_POLICIES: '/leave/policies',
  LEAVE_BALANCES: '/leave/balances',
  LEAVE_REPORTING: '/leave/reporting',

  // Performance
  APPRAISAL_REPORTING: '/performance/reporting',
  PERFORMANCE: '/performance',
  PERFORMANCE_GOALS: '/performance/goals',
  PERFORMANCE_APPRAISALS: '/performance/appraisals',
  PERFORMANCE_APPRAISAL_SUBORDINATE: '/performance/appraisals/subordinate/:id',
  PERFORMANCE_FEEDBACK: '/performance/feedback',
  APPRAISAL_CYCLES: '/settings/appraisal-cycles',

  // Documents
  DOCUMENTS: '/documents',
  DOCUMENT_REPORTING: '/documents/reporting',

  // Salary Advance
  SALARY_ADVANCE: '/salary-advance',
  SALARY_ADVANCE_APPROVALS: '/salary-advance/approvals',
  SALARY_ADVANCE_REPORTING: '/salary-advance/reporting',

  // Onboarding
  ONBOARDING: '/onboarding',
  ONBOARDING_CANDIDATES: '/onboarding/candidates',
  RECRUITMENT: '/recruitment',
  CANDIDATES: '/candidates',

  // Offboarding
  OFFBOARDING: '/offboarding',
  EXITS: '/exits',

  // Surveys
  SURVEYS: '/surveys',

  // LMS
  LMS: '/lms',
  LMS_COURSES: '/lms/courses',
  LMS_MY_TRAINING: '/lms/my-training',

  // Reports
  REPORTS: '/reports',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_CONFIGURATION: '/settings/configuration',
  SETTINGS_CUSTOMIZATION: '/settings/customization',
  SETTINGS_PROFESSIONAL: '/settings/professional',
  SETTINGS_LEAVE_CYCLES: '/settings/leave-cycles',
  SETTINGS_LMS: '/settings/lms',
  SETTINGS_POLICIES_ADMIN: '/settings/policies-admin',

  // Roles & Permissions
  ROLES: '/roles',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
